import React from "react";
import { Link } from "react-router-dom";
import { CONTACT, ASSETS } from "@/lib/pnp";
import { Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-white border-t border-[#DFEBE4] pt-14 pb-10 px-6 md:px-12">
      <div className="grid grid-cols-12 gap-6 items-start">
        <div className="col-span-12 md:col-span-5 flex items-center gap-3">
          <div className="h-11 w-11 rounded-full overflow-hidden ring-1 ring-[#DFEBE4]">
            <img src={ASSETS.logo} alt="P&P Gartenservice" className="h-full w-full object-cover" />
          </div>
          <div>
            <div className="font-display font-bold text-[#082E19] tracking-tight">P&amp;P Gartenservice</div>
            <div className="font-mono-pp text-[10px] uppercase tracking-[0.22em] text-[#4F6858]">
              Für einen Garten, in dem Sie sich wohlfühlen.
            </div>
          </div>
        </div>
        <div className="col-span-6 md:col-span-3">
          <div className="font-mono-pp text-[10px] uppercase tracking-[0.22em] text-[#4F6858] mb-2">Kontakt</div>
          <a href={CONTACT.telHref} className="block text-[#082E19] font-medium hover:text-[#17C964]">{CONTACT.phone}</a>
          <a href={CONTACT.emailHref} className="block text-[#082E19] font-medium hover:text-[#17C964] break-all">{CONTACT.email}</a>
        </div>
        <div className="col-span-6 md:col-span-2">
          <div className="font-mono-pp text-[10px] uppercase tracking-[0.22em] text-[#4F6858] mb-2">Einzugsgebiet</div>
          <div className="text-[#082E19] font-medium">Grünberg</div>
          <div className="text-[#4F6858] text-sm">15 km Umkreis</div>
        </div>
        <div className="col-span-12 md:col-span-2 flex md:justify-end">
          <a
            href={CONTACT.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="inline-flex items-center gap-2 h-10 px-4 rounded-full border border-[#DFEBE4] text-[#082E19] hover:bg-[#082E19] hover:text-white transition-colors"
          >
            <Instagram size={16} />
            <span className="font-mono-pp text-[11px] uppercase tracking-[0.22em]">Instagram</span>
          </a>
        </div>
      </div>
      <div className="mt-10 pt-6 border-t border-[#DFEBE4] flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[11px] font-mono-pp uppercase tracking-[0.2em] text-[#4F6858]">
        <div>© {new Date().getFullYear()} P&amp;P Gartenservice · Paul Drechsler</div>
        <div className="flex flex-wrap gap-5 md:gap-6 items-center">
          <Link to="/impressum" data-testid="footer-impressum-link" className="hover:text-[#082E19] transition-colors">
            Impressum
          </Link>
          <Link to="/datenschutz" data-testid="footer-datenschutz-link" className="hover:text-[#082E19] transition-colors">
            Datenschutz
          </Link>
          <span className="hidden md:inline">Zuverlässig · Sauber · Fair</span>
        </div>
      </div>
    </footer>
  );
}
